import { render, staticRenderFns } from "./q5.vue?vue&type=template&id=24f8485e&scoped=true&"
import script from "./q5.vue?vue&type=script&lang=js&"
export * from "./q5.vue?vue&type=script&lang=js&"
import style0 from "./q5.vue?vue&type=style&index=0&id=24f8485e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8485e",
  null
  
)

export default component.exports